// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --riple-color: transparent;
  --background-focused: transparent;
  --border-style: none;
  --box-shadow: none;
}

.icon-only {
  font-size: var(--icon-size, 22px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,mCAAA;EACA,+BAAA;EACA,0BAAA;EACA,iCAAA;EACA,oBAAA;EACA,kBAAA;AACD;;AAEA;EACC,4CAAA;AACD","sourcesContent":["ion-button {\n\t--background: transparent;\n\t--background-activated: transparent;\n\t--background-hover: transparent;\n\t--riple-color: transparent;\n\t--background-focused: transparent;\n\t--border-style: none;\n\t--box-shadow: none;\n}\n\n.icon-only {\n\tfont-size: var(--icon-size, 22px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
